import { render, staticRenderFns } from "./FilePreview.vue?vue&type=template&id=097903da&scoped=true&"
import script from "./FilePreview.vue?vue&type=script&setup=true&lang=ts&"
export * from "./FilePreview.vue?vue&type=script&setup=true&lang=ts&"
import style0 from "./FilePreview.vue?vue&type=style&index=0&id=097903da&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "097903da",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/prodoctorov/pd-ssr/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('097903da')) {
      api.createRecord('097903da', component.options)
    } else {
      api.reload('097903da', component.options)
    }
    module.hot.accept("./FilePreview.vue?vue&type=template&id=097903da&scoped=true&", function () {
      api.rerender('097903da', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/pages/appointment/uslugi/new/components/ServiceAppointmentForm/components/AttachedFiles/components/FilePreview/FilePreview.vue"
export default component.exports